exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardLabel[data-v-7f30d069]{cursor:pointer}.cardLabel.is-selected[data-v-7f30d069]{filter:drop-shadow(0 0 2px red)}.handCardsWrapper[data-v-7f30d069]{position:fixed;z-index:100;height:250px;width:100%;bottom:0;background:rgba(249,251,231,.9);overflow-x:auto}.discardCheckBox[data-v-7f30d069],.handCardsBox[data-v-7f30d069]{display:flex;flex-wrap:nowrap}.discardCheck[data-v-7f30d069]{text-align:center}.discardCheck[data-v-7f30d069],.handCardDummy[data-v-7f30d069]{width:80px;margin:.25rem;flex:0 0 80px;min-width:80px}.handCardDummy[data-v-7f30d069]{height:120px;position:relative}hand-card[data-v-7f30d069]{cursor:pointer}", ""]);

// exports
